/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crisp_Light_Gull_SpotInputs */

const en_crisp_light_gull_spot = /** @type {(inputs: Crisp_Light_Gull_SpotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluded`)
};

const de_crisp_light_gull_spot = /** @type {(inputs: Crisp_Light_Gull_SpotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgeschlossen`)
};

/**
* | output |
* | --- |
* | "Excluded" |
*
* @param {Crisp_Light_Gull_SpotInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const crisp_light_gull_spot = /** @type {((inputs?: Crisp_Light_Gull_SpotInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crisp_Light_Gull_SpotInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crisp_light_gull_spot(inputs)
	return de_crisp_light_gull_spot(inputs)
});